import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-full animate-pulse bg-gray-200"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 3,
  class: "w-full h-full flex items-center justify-center text-gray-400 text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "cropped-face bg-gray-100 overflow-hidden",
    style: _normalizeStyle(_ctx.containerStyle)
  }, [
    (!_ctx.imageLoaded && !_ctx.failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.imageLoaded && _ctx.bbox)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "w-full h-full",
          style: _normalizeStyle(_ctx.cropStyle)
        }, null, 4))
      : (_ctx.imageLoaded && !_ctx.bbox)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: _ctx.src,
            alt: _ctx.alt,
            class: "w-full h-full object-cover"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
    (_ctx.failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.alt), 1))
      : _createCommentVNode("", true)
  ], 4))
}